var _defs, _rect, _path, _rect2, _text, _text2, _circle, _text3, _rect3, _text4, _text5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCoverCommunityQuiz(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1200,
    height: 760,
    viewBox: "0 0 1200 760",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img",
    "aria-label": "Quiz and engagement platform",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "bg",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#0f172a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#334155"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 1200,
    height: 760,
    fill: "url(#bg)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 650C220 560 340 740 560 670C760 605 930 760 1200 650V760H0Z",
    fill: "#f97316",
    opacity: 0.18
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 90,
    y: 110,
    width: 1020,
    height: 540,
    rx: 30,
    fill: "#111827",
    stroke: "#f97316",
    strokeOpacity: 0.42
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 150,
    y: 210,
    fill: "#f8fafc",
    fontFamily: "Segoe UI, Arial, sans-serif",
    fontSize: 44,
    fontWeight: 800
  }, "QUIZ &amp; ENGAGEMENT")), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 150,
    y: 250,
    fill: "#cbd5e1",
    fontFamily: "Segoe UI, Arial, sans-serif",
    fontSize: 24
  }, "Leaderboard, participation, result analytics")), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 250,
    cy: 410,
    r: 80,
    fill: "#f97316"
  })), _text3 || (_text3 = /*#__PURE__*/React.createElement("text", {
    x: 250,
    y: 425,
    fill: "#111827",
    fontFamily: "Segoe UI, Arial, sans-serif",
    fontSize: 64,
    fontWeight: 800,
    textAnchor: "middle"
  }, "?")), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 380,
    y: 330,
    width: 650,
    height: 200,
    rx: 16,
    fill: "#0f172a",
    stroke: "#475569"
  })), _text4 || (_text4 = /*#__PURE__*/React.createElement("text", {
    x: 420,
    y: 398,
    fill: "#f8fafc",
    fontFamily: "Segoe UI, Arial, sans-serif",
    fontSize: 24,
    fontWeight: 700
  }, "NestJS  MySQL  JWT  Swagger")), _text5 || (_text5 = /*#__PURE__*/React.createElement("text", {
    x: 420,
    y: 440,
    fill: "#cbd5e1",
    fontFamily: "Segoe UI, Arial, sans-serif",
    fontSize: 20
  }, "Internal users, secure access, reporting")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoverCommunityQuiz);
export default __webpack_public_path__ + "static/media/cover-community-quiz.db881ad961861647f4177dcfa272c8a7.svg";
export { ForwardRef as ReactComponent };